import React from 'react';
import ProductIcon, { BigProductWatermark } from './ProductIcon';

const badgeFor = (stock) => {
  if (stock <= 0) return { text: 'OUT OF STOCK', cls: 'text-[#ef4444] bg-[#1a0d0d] border-[#3a1a1a]' };
  if (stock <= 3) return { text: `${stock} LEFT`, cls: 'text-[#f59e0b] bg-[#1a1408] border-[#3a2a10]' };
  return { text: `${stock} LEFT`, cls: 'text-[#22c55e] bg-[#0f1a12] border-[#1f3a24]' };
};

const ProductCard = ({ product, onSelect }) => {
  const outOfStock = (product.stock || 0) <= 0;
  const badge = badgeFor(product.stock || 0);

  const handleClick = () => {
    if (onSelect) onSelect(product);
  };

  return (
    <div
      role="button"
      tabIndex={0}
      onClick={handleClick}
      onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); handleClick(); } }}
      className="relative border border-[#151515] bg-[#0a0a0a] rounded-md p-4 hover:border-[#22c55e]/40 transition-colors overflow-hidden group cursor-pointer focus:outline-none focus:border-[#22c55e]"
    >
      <BigProductWatermark type={product.icon} />

      <div className={`inline-flex items-center px-2 py-0.5 text-[10px] tracking-[0.2em] font-mono border rounded-sm ${badge.cls}`}>
        {badge.text}
      </div>

      <div className="mt-3 flex items-start gap-2.5 min-h-[48px]">
        <ProductIcon type={product.icon} size={16} />
        <div className="text-[13px] tracking-[0.05em] text-[#e6e6e6] leading-snug font-mono uppercase">{product.name}</div>
      </div>

      <div className="mt-5 space-y-1.5 font-mono">
        <div className="flex items-center justify-between text-[12px]">
          <span className="text-[#5a5a5a] tracking-[0.2em]">USDT</span>
          <span className="text-[#e6e6e6]">${Number(product.usdt).toFixed(2)}</span>
        </div>
        <div className="flex items-center justify-between text-[12px]">
          <span className="text-[#5a5a5a] tracking-[0.2em]">INR</span>
          <span className="text-[#e6e6e6]">₹{Number(product.inr).toFixed(2)}</span>
        </div>
      </div>

      <button
        type="button"
        onClick={(e) => { e.stopPropagation(); handleClick(); }}
        disabled={outOfStock}
        className={`mt-4 w-full py-2 text-[11px] tracking-[0.25em] font-mono rounded-sm transition-colors ${
          outOfStock
            ? 'bg-transparent text-[#5a5a5a] border border-[#1f1f1f] cursor-not-allowed'
            : 'border border-[#1f1f1f] text-[#8a8a8a] hover:bg-[#22c55e] hover:text-black hover:border-[#22c55e]'
        }`}
      >
        {outOfStock ? 'SOLD OUT' : 'BUY NOW'}
      </button>
    </div>
  );
};

export default ProductCard;
